import { render, staticRenderFns } from "./TableRowNumTestsPerTech.vue?vue&type=template&id=2e01f4ec&lang=pug&"
import script from "./TableRowNumTestsPerTech.vue?vue&type=script&lang=js&"
export * from "./TableRowNumTestsPerTech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e01f4ec')) {
      api.createRecord('2e01f4ec', component.options)
    } else {
      api.reload('2e01f4ec', component.options)
    }
    module.hot.accept("./TableRowNumTestsPerTech.vue?vue&type=template&id=2e01f4ec&lang=pug&", function () {
      api.rerender('2e01f4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/tracking-sheet/table-rows/TableRowNumTestsPerTech.vue"
export default component.exports